import Bouncer from "formbouncerjs";
import A11yDialog from "a11y-dialog";
 
export default () => {
	// if (window.location.href.includes("ee/get-connected")) {
	// 	// processorPath = "/inc/ee-form-process.php";

	// 	console.log("new form script");

	// 	let form = document.querySelector("#registration-form");
	// 	let formSubmit = document.querySelector("#eeFormSubmit");

	// 	// console.log("#form: ", form);

	// 	formSubmit.addEventListener("click", function (e) {
	// 		e.preventDefault(); //stop form from submitting
	// 		let firstNameField = document.querySelector("#firstName").value;
	// 		let lastNameField = document.querySelector("#lastName").value;
	// 		let emailField = document.querySelector("#email").value;
	// 		let zipField = document.querySelector("#zip").value;
	// 		let secondFaxNumber = document.querySelector("#secondFaxNumber").value;

	// 		if (firstNameField && lastNameField && emailField && zipField && secondFaxNumber == '') {
	// 			var formData = jQuery(form).serialize();
	// 			console.log("formData:", formData);

	// 			jQuery.ajax({
	// 				method: "POST",
	// 				url: "/inc/ee-form-process.php",
	// 				data: formData,
	// 				success: function (result) {
	// 					console.log(JSON.parse(result));
	// 					//console.log('result:',result);
	// 					let formToHide = document.querySelector("#sign-up");
	// 					let thanksToShow = document.querySelector("#thank-you");
	// 					formToHide.classList.toggle("hidden");
	// 					thanksToShow.classList.toggle("hidden");
    //         window.scrollTo(0, 0);
	// 				},
	// 				error: function (error) {
	// 					console.log("error: ", JSON.parse(error));
	// 					//console.log('error:',error);
	// 				},
	// 				// complete: function (result) {
	// 				// 	console.log("complete: ", result);
	// 				// },
	// 			});
	// 		} else {
	// 			if (!firstNameField) {
	// 				if (document.querySelector("#bouncer-error_firstName")) {
	// 					document.querySelector("#bouncer-error_firstName").innerHTML = '<div class="error-message" id="bouncer-error_firstName">Please enter your first name.</div>';
	// 				} else {
	// 					jQuery('<div class="error-message" id="bouncer-error_firstName">Please enter your first name.</div>').insertAfter(document.querySelector("#firstName"));
	// 				}
	// 			}
	// 			if (!lastNameField) {
	// 				if (document.querySelector("#bouncer-error_lastName")) {
	// 					document.querySelector("#bouncer-error_lastName").innerHTML = '<div class="error-message" id="bouncer-error_lastName">Please enter your last name.</div>';
	// 				} else {
	// 					jQuery('<div class="error-message" id="bouncer-error_lastName">Please enter your last name.</div>').insertAfter(document.querySelector("#lastName"));
	// 				}
	// 			}
	// 			if (!emailField) {
	// 				if (document.querySelector("#bouncer-error_email")) {
	// 					document.querySelector("#bouncer-error_email").innerHTML = '<div class="error-message" id="bouncer-error_email">Please enter your email address.</div>';
	// 				} else {
	// 					jQuery('<div class="error-message" id="bouncer-error_email">Please enter your email address.</div>').insertAfter(document.querySelector("#email"));
	// 				}
	// 			}
	// 			if (!zipField) {
	// 				if (document.querySelector("#bouncer-error_zip")) {
	// 					document.querySelector("#bouncer-error_zip").innerHTML = '<div class="error-message" id="bouncer-error_zip">Please enter your zip code.</div>';
	// 				} else {
	// 					jQuery('<div class="error-message" id="bouncer-error_zip">Please enter your zip code.</div>').insertAfter(document.querySelector("#zip"));
	// 				}
	// 			}
	// 			return;
	// 		}
	// 	});
	// } else {
		let form = document.querySelector(".form");
		// If the page already has filled in entries
		let inputs = document.querySelectorAll(".form-control");
		if (inputs) {
			for (let i = 0; i < inputs.length; i++) {
				if (inputs[i].value) {
					inputs[i].classList.add("hasvalue");
				}
			}
		}

		// Listen for updates
		document.addEventListener("change", (e) => {
			let input = e.target;
			if (input.value) {
				input.classList.add("hasvalue");
			} else {
				input.classList.remove("hasvalue");
			}
		});

		let contact = document.querySelector("#contactMe");
		let hidden = document.querySelector(".form-field__hidden");

		if (contact) {
			contact.addEventListener("change", (e) => {
				hidden.classList.toggle("hidden");
			});
		}

		let bouncer = new Bouncer("[data-validate]", {
			customValidations: {
				confirmEmail(field) {
					// Look for a selector for a field to compare
					// If there isn't one, return false (no error)
					let selector = field.getAttribute("data-bouncer-match");
					if (!field) return false;

					// Get the field to compare
					let otherField = field.form.querySelector(`#${selector}`);
					if (!otherField) return false;

					// Compare the two field values
					// We use a negative comparison here because if they do match, the field validates
					// We want to return true for failures, which can be confusing
					return otherField.value !== field.value;
				},
				confirmAge(field) {
					// if radio has this attribute, check if it's been selected
					return !field.hasAttribute("data-bouncer-age") ? false : field.checked;
				},
			},
			messages: {
				missingValue: {
					default: function (field) {
						return field.getAttribute("data-bouncer-message");
					},
				},
			},
			//native form submission is suppressed even when form validates
			disableSubmit: true,
		});

		document.addEventListener("bouncerFormInvalid", () => {
			form.classList.add("error");
		});

		document.addEventListener("bouncerFormValid", () => {
			form.classList.remove("error");
			let formData = new FormData(form);
            let secondFaxNumber = document.querySelector("#secondFaxNumber").value;
            if (secondFaxNumber != '') {
                return;
            }
			// Detect if user is on IE browser
			var isIE = !!window.MSInputMethodContext && !!document.documentMode;

			if (isIE) {
				// Create Promise polyfill script tag
				var promiseScript = document.createElement("script");
				promiseScript.type = "text/javascript";
				promiseScript.src = "https://cdnjs.cloudflare.com/ajax/libs/promise-polyfill/8.2.0/polyfill.min.js";

				// Create Fetch polyfill script tag
				var fetchScript = document.createElement("script");
				fetchScript.type = "text/javascript";
				fetchScript.src = "https://cdn.jsdelivr.net/npm/whatwg-fetch@3.4.0/dist/fetch.umd.min.js";

				// Add polyfills to head element
				document.head.appendChild(promiseScript);
				document.head.appendChild(fetchScript);

				// Wait for the polyfills to load and run the function.
				// We could have done this differently,
				// but I've found it to work well for my use-cases
				setTimeout(function () {
					window
						.fetch("../inc/form-process.php", {
							method: "post",
							body: formData,
						})
						.then((resp) => resp.json())
						.then((data) => {
							console.log(data);
							const dialog = new A11yDialog(document.querySelector("#external2"));
							dialog.show();
							form.reset();
							hidden.classList.toggle("hidden");
						})
						.catch((error) => {
							console.error("Error: ", error);
						});
				}, 1000);
			} else {
				// If fetch is supported, just run the fetch function
				fetch("../inc/form-process.php", {
					method: "post",
					body: formData,
				})
					.then((resp) => resp.json())
					.then((data) => {
						console.log(data);
						const dialog = new A11yDialog(document.querySelector("#external2"));
						dialog.show();
						form.reset();
						hidden.classList.toggle("hidden");
					})
					.catch((error) => {
						console.error("Error: ", error);
					});
			}
		});
	// }
};

((registerTask) => {
	// registerTask('ee-register-form-errors', (task) => {
	// 	$('#eeFormSubmit').click();
	// 	task.complete(-1);
	// });
	// registerTask('ee-register-confirm', (task) => {
	// 	document.querySelector("#sign-up").classList.toggle("hidden");
	// 	document.querySelector("#thank-you").classList.toggle("hidden");
	// 	task.complete(-1);
	// });
	registerTask('register-form-errors', (task) => {
		document.querySelector('#registration-form button[type="submit"]').click();
		task.complete(-1);
	});
	registerTask('register-confirm', (task) => {
		const dialog = new A11yDialog(document.querySelector("#external2"));
		dialog.show();
		setTimeout(() => {
			document.querySelector('#external2 button.dialog-close').blur();
			task.complete(1000);
		}, 2000);
	});
})(Evoke.Screenshots.Setup.registerTask);
